/* global md5:true */
import {
	LOGIN_ACTION,
	LOGOUT_ACTION,
	SET_TOKEN_ACTION,
	LOGIN_REST_STARTED,
	LOGIN_REST_SUCCESS,
	LOGIN_REST_FAILED
} from "./LoginActions";

const loginReducer = (
	state = { isLoggedIn: false, exampleToken: null, loginData: null, error: null },
	action
) => {
	switch (action.type) {
		case SET_TOKEN_ACTION:
			return {
				...state,
				exampleToken: action.token
			};
		case LOGIN_ACTION:
			let newState = { ...state };

			if (
				!action.username ||
				action.username.trim() === "" ||
				!action.password ||
				action.password.trim() === ""
			) {
				newState.isLoggedIn = false;
				newState.error = "USERNAME_OR_PASSWORD_REQUIRED";
				return newState;
			}
			let exampleToken = newState.exampleToken.toLocaleLowerCase();
			let md5UsernamePassword = md5(
				action.username.toLocaleLowerCase() + action.password
			).toLocaleLowerCase();

			if (exampleToken === md5UsernamePassword) {
				newState.isLoggedIn = true;
				newState.error = null;
			} else {
				newState.isLoggedIn = false;
				newState.error = "USERNAME_OR_PASSWORD_WRONG";
			}

			return newState;

		case LOGOUT_ACTION:
			return {
				...state,
                isLoggedIn: false,
                loginData: null,
				error: null
            };
        case LOGIN_REST_STARTED:
            return {
                ...state
            }
        case LOGIN_REST_SUCCESS:
            return {
                ...state,
                loginData: action.loginData,
                isLoggedIn: true
            }
        case LOGIN_REST_FAILED:
            return {
                ...state,
                error: action.loginError.message,
                isLoggedIn: false
            }
		default:
			return state;
	}
};

export default loginReducer;



// WEBPACK FOOTER //
// ./src/features/common/login/login-form/LoginReducer.jsx